import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { components } from 'react-select';
import arrowDown from '../../../../assets/arrowDownBlack.svg';
import arrowUp from '../../../../assets/arrowUpBlack.svg';
import cross from '../../../../assets/cross.svg';
import edit from '../../../../assets/edit.svg';
import Button from '../../../../components/reusable/Button/Button';
import Select from '../../../../components/reusable/Select/Select';
import Tab from '../../../../components/reusable/TabsV2/Tab';
import TabsV2 from '../../../../components/reusable/TabsV2/TabsV2';
import ToggleSwitch from '../../../../components/reusable/ToggleSwitch';
import { VIEW_CHILD_TAB } from '../../../../contants/dashboard';
import { useSelectPositionLeft } from '../../../../hooks/useSelectPositionLeft';
import css from '../../Dashboard.module.css';
import styles from './styles.module.css';
import { DASHBOARD_TABS } from '../../../../contants';

const customOption = (
  onDelete,
  onEdit,
  { data, children, isSelected, isFocused, ...props },
) => {
  const isModifyButton = children === VIEW_CHILD_TAB.MODIFY_COLUMNS.label;
  const classNameOptionsIsButton = `${css.viewOptionModifyColumn}`;
  const classNameOption = `${css.viewOption} ${
    isSelected ? css.viewOptionSelected : ''
  }`;

  const handleDelete = async e => {
    e.stopPropagation();
    if (onDelete) await onDelete(data);
  };

  const handleEdit = async e => {
    e.stopPropagation();
    if (onDelete) await onEdit(data);
  };

  const renderChildren = () => {
    const isCustomView = Object.values(VIEW_CHILD_TAB).every(
      view => view.label !== children,
    );

    if (isCustomView) {
      const nameCustomView = JSON.parse(children)?.name;

      return (
        <div className={css.customViewSelection}>
          <div>
            <div className={css.customViewLabelSelection}>{nameCustomView}</div>
          </div>
          <div className={css.customViewAction}>
            <img src={edit} alt="edit_icon" onClick={handleEdit} />
            <img
              src={close}
              alt="close_icon"
              className={css.closeIcon}
              onClick={handleDelete}
            />
          </div>
        </div>
      );
    } else if (isModifyButton) return children;
    else return <div className={css.labelContainer}>{children}</div>;
  };

  return (
    <components.Option
      {...props}
      className={
        isModifyButton ? `${classNameOptionsIsButton}` : `${classNameOption}`
      }
    >
      {renderChildren()}
    </components.Option>
  );
};

const customValueContainer = ({ children, ...props }) => {
  const tempChildren = [...children];
  if (props.hasValue) {
    let value = props.getValue()[0].label;
    const isCustomView = Object.values(VIEW_CHILD_TAB).every(
      view => view.label !== value,
    );

    if (isCustomView) {
      value = JSON.parse(value)?.name;
    }

    tempChildren[0] = <span className={css.valueSelect}>View: {value}</span>;
  }

  return (
    <components.ValueContainer {...props}>
      {props.hasValue ? tempChildren : children}
    </components.ValueContainer>
  );
};

export default function DashboardTableBar({
  viewValue,
  onShowChart,
  isShowingChart,
  isShowComparison,
  isShowingFilters,
  isShowAddOrRemoveCampaignBtn,
  isShowAddNewBudgetBtn,
  typeSelected,
  setIsShowComparison,
  onChangeTab,
  onChangeTabView,
  onOpenDeleteCustomView,
  onEditCustomView,
  onClearFilters,
  onAddNewBudget,
  onChange,
}) {
  const [value, setValue] = useState('clients');

  const { viewOptions, tab2, tab } = useSelector(state => state.dashboard);
  const wrapperSelectRef = useRef(null);
  const selectPosLeft = useSelectPositionLeft(wrapperSelectRef);

  useEffect(() => {
    setValue(tab);
  }, [tab]);

  return (
    <div className={`${styles.dashboardTableBarContainer}`}>
      <div className="">
        <TabsV2 value={value} onChange={onChangeTab}>
          {DASHBOARD_TABS.map(tab => (
            <Tab key={tab.value} value={tab.value}>
              {tab.label}
            </Tab>
          ))}
        </TabsV2>
        {isShowingFilters ? (
          <div className={`${styles.selectedWrapper}`}>
            <>
              <div className={styles.selectedContainer}>
                <span className={styles.selectedText}>{typeSelected}</span>

                <button className={`${styles.cancelSelectedBtn}`}>
                  <img src={cross} onClick={onClearFilters} />
                </button>
              </div>

              {isShowAddOrRemoveCampaignBtn && (
                <Button
                  styled="addSource"
                  onClick={onChange}
                  style={{
                    width: 200,
                    marginLeft: 13,
                  }}
                >
                  <div className={styles.btnWrapper}>
                    <span className={styles.addText}>
                      Add or Remove Campaigns
                    </span>
                  </div>
                </Button>
              )}

              {isShowAddNewBudgetBtn && (
                <Button
                  styled="addSource"
                  onClick={onAddNewBudget}
                  style={{
                    marginLeft: 12,
                  }}
                >
                  <div className={styles.btnWrapper}>
                    <span className={styles.addText}>Add New Budget</span>
                  </div>
                </Button>
              )}
            </>
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className={`${styles.viewSelector}`}>
        {tab2 === 'performance' && (
          <ToggleSwitch
            label="Show Comparison"
            name="show_comparison"
            checked={isShowComparison}
            onChange={e => setIsShowComparison(e.target.checked)}
          />
        )}

        <div ref={wrapperSelectRef} className={`${css.selectWrapper}`}>
          <Select
            options={viewOptions}
            value={viewValue}
            onChange={onChangeTabView}
            className={css.viewSelect}
            customOption={props =>
              customOption(onOpenDeleteCustomView, onEditCustomView, props)
            }
            customValueContainer={customValueContainer}
            stylePlaceholder={{
              margin: '0',
              fontSize: '1.4rem',
            }}
            styleSingleValue={{
              whiteSpace: 'nowrap',
              margin: '0',
              fontSize: '1.4rem',
            }}
            styleInput={{
              margin: '0',
              minWidth: '0',
              height: '0',
            }}
            styleMenuPortal={{
              width: '36rem',
              left: selectPosLeft,
            }}
          />
        </div>
        <button
          className={`${styles.arrowButton}`}
          onClick={() => onShowChart && onShowChart()}
        >
          <img src={isShowingChart ? arrowUp : arrowDown} />
        </button>
      </div>
    </div>
  );
}
